export default [
  {
    device_type: 1,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 2,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 7,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 8,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 10,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 11,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 12,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 13,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 14,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 15,
    scenario_type: { 0: "سناریو خارجی", 1: "ورودی", 2: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
        {
          name: 7,
          value: 11,
        },
        {
          name: 8,
          value: 12,
        },
        {
          name: 9,
          value: 13,
        },
        {
          name: 10,
          value: 14,
        },
        {
          name: 11,
          value: 15,
        },
        {
          name: 12,
          value: 16,
        },
      ],
      2: [
        {
          name: 1,
          value: 17,
        },
        {
          name: 2,
          value: 18,
        },
        {
          name: 3,
          value: 19,
        },
        {
          name: 4,
          value: 20,
        },
        {
          name: 5,
          value: 21,
        },
        {
          name: 6,
          value: 22,
        },
        {
          name: 7,
          value: 23,
        },
        {
          name: 8,
          value: 24,
        },
        {
          name: 9,
          value: 25,
        },
        {
          name: 10,
          value: 26,
        },
        {
          name: 11,
          value: 27,
        },
        {
          name: 12,
          value: 28,
        },
      ],
    },
  },
  {
    device_type: 5,
    scenario_type: { 0: "سناریو خارجی", 1: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
      ],
    },
  },
  {
    device_type: 4,
    scenario_type: { 0: "سناریو خارجی", 1: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
      ],
    },
  },
  {
    device_type: 9,
    scenario_type: { 0: "سناریو خارجی", 1: "ریموت" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
      ],
      1: [
        {
          name: 1,
          value: 5,
        },
        {
          name: 2,
          value: 6,
        },
        {
          name: 3,
          value: 7,
        },
        {
          name: 4,
          value: 8,
        },
        {
          name: 5,
          value: 9,
        },
        {
          name: 6,
          value: 10,
        },
      ],
    },
  },
  {
    device_type: 3,
    scenario_type: { 0: "سناریو خارجی" },
    scenario_num: {
      0: [
        {
          name: 1,
          value: 1,
        },
        {
          name: 2,
          value: 2,
        },
        {
          name: 3,
          value: 3,
        },
        {
          name: 4,
          value: 4,
        },
        {
          name: 5,
          value: 5,
        },
        {
          name: 6,
          value: 6,
        },
        {
          name: 7,
          value: 7,
        },
        {
          name: 8,
          value: 8,
        },
        {
          name: 9,
          value: 9,
        },
        {
          name: 10,
          value: 10,
        },
        {
          name: 11,
          value: 11,
        },
        {
          name: 12,
          value: 12,
        },
        {
          name: 13,
          value: 13,
        },
        {
          name: 14,
          value: 14,
        },
        {
          name: 15,
          value: 15,
        },
        {
          name: 16,
          value: 16,
        },
        {
          name: 17,
          value: 17,
        },
        {
          name: 18,
          value: 18,
        },
        {
          name: 19,
          value: 19,
        },
        {
          name: 20,
          value: 20,
        },
      ],
    },
  },
];
